import React from 'react'
import { useNavigate } from 'react-router-dom'
import { IconButton, Typography } from '@mui/material'
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'

import { defApi } from '../../../core-api'
import { useAuthStore } from '../../../context'
import WiseIcon from '../../assets/WiseLogo.svg'
import styles from './ChatHeader.module.css'
import { t } from 'i18next'

const ChatHeader: React.FC = () => {
  const { token, clearToken } = useAuthStore()
  const navigate = useNavigate()

  const onLogout = () => {
    defApi.cpaLogoutDelete({ xAccessToken: token ?? '' })

    clearToken()
    navigate('/')
  }

  return (
    <div className={styles.root}>
      <IconButton onClick={onLogout}>
        <ArrowBackIcon className={styles.logoutIcon} fontSize='medium' />
      </IconButton>

      <img src={WiseIcon} alt='Logo' />

      <div>
        <Typography fontSize='18px' color='#121212'>
          {t('chat-bot.chat-header.ai-assistant')}
        </Typography>
        <Typography fontSize='15px' color='#3ABF38'>
          ● {t('chat-bot.chat-header.online')}
        </Typography>
      </div>
    </div>
  )
}

export default ChatHeader
